import { render, staticRenderFns } from "./FooterAlleFolders.vue?vue&type=template&id=73360606&"
import script from "./FooterAlleFolders.vue?vue&type=script&lang=ts&"
export * from "./FooterAlleFolders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports